<section class="asset-management-section">
  <ts-page-header>
    <ng-container page-header-title>
      <p class="font-ts-header-title text-ts-header-title">{{ title }}</p>
    </ng-container>
    <ng-container page-header-action-buttons>
      <section class="flex flex-row items-center gap-2">
        @if (enableExport) {
          <ts-button color="accent" variant="secondary" icon="ts_file-save" (click)="exportAccountingReport.emit()">
            Export
          </ts-button>
        }

        @if (enableImport) {
          <ts-button
            [matMenuTriggerFor]="menu"
            [menuIcon]="true"
            [loading]="importLoading"
            icon="add"
            variant="primary"
          >
            Import
          </ts-button>
          <mat-menu #menu="matMenu" xPosition="before">
            <ng-container *ngTemplateOutlet="importSources; context: { source: 'yardi' }"></ng-container>
            <ng-container *ngTemplateOutlet="importSources; context: { source: 'sage' }"></ng-container>
            <ng-container *ngTemplateOutlet="importSources; context: { source: 'entrata' }"></ng-container>
            <ng-container *ngTemplateOutlet="importSources; context: { source: 'mri' }"></ng-container>
          </mat-menu>
        }
      </section>
    </ng-container>
    <ng-container page-header-action-bar>
      <div class="w-full flex flex-row items-center justify-start gap-2">
        @if (accountFilterSearchEnabled) {
          <ts-input
            size="sm"
            placeholder="Filter accounts"
            icon="ts_search"
            class="max-w-1/5"
            [formControl]="filterAccountsForm"
          ></ts-input>
        }

        <report-period-selector
          [loading]="accountingReportLoading"
          [reportPeriod]="reportPeriod"
          (reportPeriodChanged)="reportPeriodChanged.next($event)"
        />
      </div>
    </ng-container>
  </ts-page-header>

  <ts-table
    [autoHeight]="false"
    [rowData]="_accountingReportPage?.results"
    [columnDefs]="columnDefs"
    [loading]="accountingReportLoading"
    (sortChanged)="onSortChanged($event)"
  ></ts-table>

  <ts-paginator
    [pageSize]="_accountingReportPage?.per_page"
    [activePage]="_accountingReportPage?.page"
    [totalItems]="_accountingReportPage?.count"
    (pageChanged)="onPageChanged($event)"
  />
</section>

<ng-template #importSources let-source="source">
  <input
    hidden
    type="file"
    accept=".pdf, .xls, .xlsx"
    #fileInput
    (change)="this.importAccountingReport.emit({ file: $event?.target?.files[0], source: source })"
  />
  <button mat-menu-item (click)="fileInput.click()">{{ source | titlecase }}</button>
</ng-template>
